export default function WhyChooseBhavya() {
  const features = [
    {
      icon: "📚",
      title: "Quality Books",
      desc: "Expertly designed books for every class.",
    },
    {
      icon: "🎥",
      title: "Chapter-wise Videos",
      desc: "Learn visually with easy-to-follow videos.",
    },
    {
      icon: "📖",
      title: "Interactive E-Books",
      desc: "Study anytime, anywhere.",
    },
    {
      icon: "🏆",
      title: "Student Friendly",
      desc: "Simple and engaging content.",
    },
    {
      icon: "🎨",
      title: "Creative Learning",
      desc: "Colourful books kids love.",
    },
    {
      icon: "⭐",
      title: "Trusted Partner",
      desc: "Helping students learn confidently.",
    },
  ];

  return (
    <section className="py-24 bg-[#FFF9F4]">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-5xl font-bold text-center text-[#4D96FF]">
          ✨ Why Choose Bhavya?
        </h2>

        <p className="text-center text-gray-600 mt-5 text-lg">
          Making learning enjoyable for every student.
        </p>

        <div className="grid md:grid-cols-3 gap-8 mt-16">
          {features.map((item, index) => (
            <div
              key={index}
              className="
bg-white
rounded-3xl
p-8
shadow-lg
hover:-translate-y-3
hover:shadow-2xl
transition-all
duration-300
"
            >
              <div className="text-5xl">{item.icon}</div>

              <h3 className="text-2xl font-bold mt-5">{item.title}</h3>

              <p className="mt-4 text-gray-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
